import { useEffect, useState, FunctionComponent } from 'react';
import './FooterBlocky.scss';
import abtaImg from '../assets/footerBlocky/ABTA_White.svg'
import atolImg from '../assets/footerBlocky/atol_white.svg';
import facebookImg from '../assets/footerBlocky/facebook.svg';
import instaImg from '../assets/footerBlocky/instagram.svg';
import mapImg from '../assets/footerBlocky/map-pin.svg';
import personImg from '../assets/footerBlocky/person.svg';
import phoneImg from '../assets/footerBlocky/phone.svg';
import tikImg from '../assets/footerBlocky/tiktok.svg';
import tubeImg from '../assets/footerBlocky/youtube.svg';
import xImg from '../assets/footerBlocky/x.svg';
import whatsAppImg from '../assets/footerBlocky/whatsapp.svg';

interface FooterBlockyProps {
    userToken: string
    userConfiguration: any
}

const FooterBlocky: FunctionComponent<FooterBlockyProps> = ({
    userToken,
    userConfiguration
}) => {


    if (userConfiguration.footer.blocky == null) {
        return null;
    }

    let facebook = null;
    if (userConfiguration.facebook_url != "") {
        facebook = <a href={userConfiguration.facebook_url} target='_blanc'>
            <img
                className="bf-footer__social-icon"
                src={facebookImg}
                alt="Facebook"
            />
        </a>
    }
    let insta = null;
    if (userConfiguration.insta_url != "") {

        insta = <a href={userConfiguration.insta_url} target='_blanc'>
            <img
                className="bf-footer__social-icon"
                src={instaImg}
                alt="Instagram"
            />
        </a>;

    }
    let tiktok = null;
    if (userConfiguration.tiktok_url != "") {

        tiktok = <a href={userConfiguration.tiktok_url} target='_blanc'>
            <img
                className="bf-footer__social-icon"
                src={tikImg}
                alt="TikTok"
            />
        </a>;

    }
    let youtube = null;
    if (userConfiguration.youtube_url != "") {

        youtube = <a href={userConfiguration.youtube_url} target='_blanc'>
            <img
                className="bf-footer__social-icon"
                src={tubeImg}
                alt="YouTube"
            />
        </a>
    }

    let xtwitter = null;
    if (userConfiguration.x_url != null) {

        xtwitter = <a href={userConfiguration.x_url} target='_blanc'>
            <img
                className="bf-footer__social-icon"
                src={xImg}
                alt="X Twitter"
            />
        </a>
    }

    let whatsApp = null;
    if (userConfiguration.whatsapp_url == null) {

        whatsApp = <a href={userConfiguration.whatsapp_url} target='_blanc'>
            <img
                className="bf-footer__social-icon"
                src={whatsAppImg}
                alt="whats app"
            />
        </a>
    }

    let telBox = null;
    if(userConfiguration.footer.blocky.contact_block.tel.url != ""){
        telBox =  <li>
        <div className="bf-footer__icon-wrap">
            <img
                className="bf-footer__info-icon"
                src={phoneImg}
                alt="Telephone"
                width="24"
                height="24"
            />
        </div>
        <a style={{color: userConfiguration.footer.blocky.contact_block.text_colour}} href={userConfiguration.footer.blocky.contact_block.tel.url} target='_blanc'>{userConfiguration.footer.blocky.contact_block.tel.text}</a>
    </li>
    }

    let branchBox = null;
    if(userConfiguration.footer.blocky.contact_block.branch.url != ""){
       branchBox =  <li>
        <div className="bf-footer__icon-wrap">
            <img
                className="bf-footer__info-icon"
                src={mapImg}
                alt="Map Pin"
                width="24"
                height="24"
            />
        </div>
        <a style={{color: userConfiguration.footer.blocky.contact_block.text_colour}} href={userConfiguration.footer.blocky.contact_block.branch.url} target='_blanc'>{userConfiguration.footer.blocky.contact_block.branch.title}</a>
    </li>
    }

    let conBox = null;
    if(userConfiguration.footer.blocky.contact_block.consultant.url != ""){
        conBox = <li>
        <div className="bf-footer__icon-wrap">
            <img
                className="bf-footer__info-icon"
                src={personImg}
                alt="Person"
                width="24"
                height="24"
            />
        </div>
        <a style={{color: userConfiguration.footer.blocky.contact_block.text_colour}} href={userConfiguration.footer.blocky.contact_block.consultant.url} target='_blanc'>{userConfiguration.footer.blocky.contact_block.consultant.title}</a>
    </li>
    }

    const companyLinks: any[] = [];

    for(const x of userConfiguration.footer.blocky.company_links){
        companyLinks.push(<li><a href={x.url} target='_blanc'>{x.text}</a></li>)
    }
    
    const policyLinks: any[] = [];
    for(const x of userConfiguration.footer.blocky.policy_links){
        policyLinks.push(<li><a href={x.url} target='_blanc'>{x.text}</a></li>)
    }



    const sp = [];
    const footerWords = userConfiguration.footer.small_print.split(' ');
    for (const x of footerWords) {
        if (x.indexOf('https://') != -1) {
            const jh = 500;
            sp.push(<a href={x} target='_blanc' >{x}</a>);
        }
        else {
            sp.push(x + ' ');
        }
    }

    return (<footer style={{background: userConfiguration.footer.blocky.colour, color: userConfiguration.footer.blocky.text_colour}} className="bf-footer">

        {/*         
        <div className="bf-footer__banner">
          <div className="bf-footer__banner-container">
            <form className="bf-footer__signup-form">
              <div className="bf-footer__signup-text">
                <h2>GET EXCLUSIVE OFFERS AND MUCH MORE</h2>
                <div>Sign up to your emails today...</div>
              </div>
  
              <button type="submit" className="bf-footer__button">Sign up</button>
            </form>
          </div>
        </div> */}

        <div className="bf-footer__main-block">
            <div className="bf-footer__container">

                <div className="bf-footer__grid">

                    <div className="bf-footer__info-column">
                        <h2 className="bf-footer__info-title" style={{color: userConfiguration.footer.blocky.head_colour}}>{userConfiguration.footer.blocky.op_title}</h2>

                        <div className="bf-footer__info-content">
                            <p>
                                {userConfiguration.footer.blocky.op_text}
                            </p>
                        </div>

                        <div className="bf-footer__contact-details" style={{backgroundColor: userConfiguration.footer.blocky.contact_block.colour}}>
                            <ul>
                                {telBox}

                                {branchBox}
                                  
                                {conBox}
                            
                            </ul>
                        </div>

                    </div>

                    <div className="bf-footer__links-column">
                        <h2 className="bf-footer__link-title" style={{color: userConfiguration.footer.blocky.head_colour}}>{userConfiguration.footer.blocky.company_title}</h2>
                        <ul className="bf-footer__links">
                            {companyLinks}
                        </ul>
                    </div>

                    <div className="bf-footer__links-column">
                        <h2 className="bf-footer__link-title" style={{color: userConfiguration.footer.blocky.head_colour}}>Policies</h2>
                        <ul className="bf-footer__links">
                            {policyLinks}
                        </ul>
                    </div>

                    <div className="bf-footer__info-column">
                        <h2 className="bf-footer__info-title" style={{color: userConfiguration.footer.blocky.head_colour}}>Total peace of mind</h2>

                        <div className="bf-footer__info-icons">
                            <img
                                className="bf-footer__info-icon"
                                src={abtaImg}
                                alt="ABTA"
                                width="144"
                                height="40"
                            />

                            <img
                                className="bf-footer__info-icon"
                                src={atolImg}
                                alt="ATOL"
                                width="40"
                                height="40"
                            />
                        </div>

                        <div className="bf-footer__info-content">
                            <p>{sp}</p>

                        </div>
                    </div>
                </div>


     

                <div className="bf-footer__legal-and-social">
                    <div className="bf-footer__social-links">


                        {facebook}
                        {insta}
                        {tiktok}
                        {youtube}
                        {whatsApp}
                        {xtwitter}

              

                    </div>

                    <div className="bf-footer__legal">
                        <p>
                            {userConfiguration.footer.copy_right }
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>);


}

export default FooterBlocky;